import * as React from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../store';
import './success-page.scss';
import { Trans, useTranslation } from 'react-i18next';
import { OnboardingType } from '../../domains/quote.domain';
import { PageTemplate } from '../common/page-template/page-template';

export const SuccessPage = observer(() => {
  const { t } = useTranslation('', { keyPrefix: 'SUCCESS_PAGE' });
  const { signUpStore } = useStore();
  const { onboarding } = signUpStore;

  const title = (
    <>
      <div className="container-success-checkmark">
        <span className="success-checkmark"></span>
      </div>
      <h2>{t('CONGRATULATIONS')}</h2>
    </>
  );

  const content = (
    <>
      <p>{t('YOU_ARE_ONE_STEP_CLOSER')}</p>
      <p>
        <Trans
          i18nKey={`SUCCESS_PAGE.${onboarding?.type === OnboardingType.Self ? 'SELF_TEXT' : 'DEFAULT_TEXT'}`}
          components={{ br: <br /> }}
        />
      </p>
      <p>{t('THANK_YOU')}</p>
    </>
  );

  return <PageTemplate titleElement={title} contentElement={content} />;
});
